import { getEstablishmentDefaultImage } from '@/modules/accredited-establishments/functions'

const ASSETS_HOST = 'https://s3.amazonaws.com/web.assets.alice.com.br/'

/*
 * O backend as vezes devolve foto ou logo hospedados fora do bucket de assets,
 * e o `next/image` so aceita os hosts configurados. Nesses casos entra a imagem
 * padrao da categoria.
 *
 * `category` fica `string` de proposito, e nao `EstablishmentCategory`: o
 * `GetProviderDetailResponse.category` do backend tambem e `string`, entao
 * estreitar aqui so trocaria a checagem por um cast no chamador.
 */
const getProviderDetailImage = (icon?: string, category?: string) =>
  icon?.startsWith(ASSETS_HOST) ? icon : getEstablishmentDefaultImage(category)

export { getProviderDetailImage }
